export default __webpack_public_path__ + "static/continuity-8f744cf481a18f86be32ff1b01b22866.jpeg";